class Constants {
    public static DateFormat: string = 'dd.MM.yyyy'
    public static DateTimeFormat: string = 'dd.MM.yyyy HH:mm'
}

export default Constants